<dt-modal-content (closeClick)="close()" size="small">
  <ng-template #title i18n>Neues Mitglied einladen</ng-template>
  <ng-template #content>
    <div class="virtual-container">
      <mat-slide-toggle [(ngModel)]="virtualMember" [disabled]="activeForm.disabled" (ngModelChange)="formChanged()">
        <div class="virtual-slide-toggle-container">
          <span i18n>Virtuelles Teammitglied</span>
          <mat-icon color="accent" i18n-matTooltip matTooltip="Ein Teammitglied das keinem User Account zugeordnet ist.">help</mat-icon>
        </div>
      </mat-slide-toggle>
    </div>
    <mat-divider></mat-divider>
    @if (virtualMember) {
      <form [formGroup]="virtualForm" class="dt-form">
        <mat-form-field class="dt-no-margin">
          <mat-label i18n>Name</mat-label>
          <input matInput placeholder="Name" formControlName="name" />
        </mat-form-field>
      </form>
    } @else {
      <form [formGroup]="realForm" class="dt-form">
        <mat-form-field class="dt-no-margin">
          <mat-label i18n>E-Mail-Adresse</mat-label>
          <input matInput placeholder="Email" formControlName="email" />
        </mat-form-field>
      </form>
    }
  </ng-template>
  <ng-template #footer>
    <button
      #inviteButton
      mat-raised-button
      color="accent"
      [disabled]="!activeForm.valid"
      (click)="inviteOrCreate(inviteButton)"
      [dtOverlayProgress]
    >
      @if (virtualMember) {
        <ng-container i18n>Erstellen</ng-container>
      } @else {
        <ng-container i18n>Einladen</ng-container>
      }
    </button>
    <button mat-stroked-button color="accent" (click)="close()" i18n>Abbrechen</button>
  </ng-template>
</dt-modal-content>
